module.exports = __webpack_public_path__ + "img/hyhd_logo.47438310.png";